// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__ewPox","upload":"Small_upload__dk5Wz","imageWrap":"Small_imageWrap__1pEQZ","removeBtn":"Small_removeBtn__2z-HS"};